import React from 'react';
import PropTypes from 'prop-types';

import { Provider } from 'react-redux';
import configureStore from './store/configure';

import ConnectedPipelineSettings from './pipeline_settings';
import { defaultViewConfig } from './config';
import { getInitialColumnOptions } from './helpers';

export default class PipelineSettings extends React.Component {
  static propTypes = {
    fieldsByName: PropTypes.object,
    path: PropTypes.string.isRequired,
    stagesConfig: PropTypes.object.isRequired,
    viewConfig: PropTypes.object.isRequired,
  }

  constructor(props) {
    super(props);
    this.store = configureStore({
      columnOptions: getInitialColumnOptions(props.fieldsByName, props.viewConfig?.columns),
      path: props.path,
      stages: props.stagesConfig,
      view: {
        ...defaultViewConfig,
        ...props.viewConfig,
        columns: props.viewConfig.columns.length > 0 ? props.viewConfig.columns : defaultViewConfig.columns,
      },
    });
  }

  render() {
    return (
      <Provider store={this.store}>
        <ConnectedPipelineSettings />
      </Provider>
    );
  }
}
